import { Fragment } from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";

const RenderToolTip = ({ toolTipData }) => {
  return toolTipData.map((tipData, index) => (
    <Fragment key={index}>
      <ReactTooltip
        place="top"
        type="info"
        id={tipData.id}
        effect="solid"
      >
        {tipData.text}
      </ReactTooltip>
    </Fragment>
  ));
};
RenderToolTip.propTypes = {
  toolTipData: PropTypes.array.isRequired
};

export default RenderToolTip;
